import { render, staticRenderFns } from "./IndicationForm.vue?vue&type=template&id=b7620652&scoped=true&lang=pug"
import script from "./IndicationForm.vue?vue&type=script&lang=js"
export * from "./IndicationForm.vue?vue&type=script&lang=js"
import style0 from "./IndicationForm.vue?vue&type=style&index=0&id=b7620652&prod&lang=scss"
import style1 from "./IndicationForm.vue?vue&type=style&index=1&id=b7620652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7620652",
  null
  
)

export default component.exports